import { render, staticRenderFns } from "./DragCardNfes.vue?vue&type=template&id=756767b0&scoped=true"
import script from "./DragCardNfes.vue?vue&type=script&lang=js"
export * from "./DragCardNfes.vue?vue&type=script&lang=js"
import style0 from "./DragCardNfes.vue?vue&type=style&index=0&id=756767b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756767b0",
  null
  
)

export default component.exports